<div class="section-header" >
    <div class="d-flex">
      <div class="w-100">
      <div class="container">
        <span class="h2">ARCHIVIO DOCUMENTAZIONE</span>
      </div>
      </div>
    </div>
  </div>
  
  <div class="nav-tabs-navigation pt-4" data-tabs-color="orange">
    <div class="nb-theme-default">
        <nb-tabset id="tabset-docs" fullWidth>
            <nb-tab tabTitle="Rapporti di evento" style="overflow:hidden">
                <div class="tabset-content d-flex justify-content-center">
                    <rapporti></rapporti>
                </div>
            </nb-tab>

            <nb-tab tabTitle="Ordinamento e normativa" style="overflow:hidden">
                <div class="tabset-content d-flex justify-content-center">
                    <normativa class="w-100"></normativa>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Elaborazioni climatiche" style="overflow:hidden">
                <div class="tabset-content d-flex justify-content-center">
                    <elaborazioni-climatiche class="w-100"></elaborazioni-climatiche>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Annali ex SIMN" style="overflow:hidden">
                <div class="tabset-content d-flex justify-content-center">
                    <annali class="w-100"></annali>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Monografie stazioni" style="overflow:hidden">
                <div class="tabset-content d-flex justify-content-center">
                    <monografie class="w-100"></monografie>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Altro" style="overflow:hidden">
                <div class="tabset-content d-flex justify-content-center">
                    <altro class="w-100"></altro>
                </div>
            </nb-tab>
        </nb-tabset>
    </div>
</div>
